<template>
  <RbuSectionItemPaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-rbut
    :data-url="dataUrl"
    data-key="items"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    class="rbu-item-list"
  >
    <template #item.item_remark="{ value }">
      <span>{{ parseRemark(value) }} </span>
    </template>
    <template #item.need_manual_update="{ value }">
      <v-icon color="red" v-if="value">mdi-exclamation-thick</v-icon>
    </template>
    <template #item.manually_selected_rate="{ value, item }">
      <v-icon color="grey" v-if="value" @click="resetManuallySelected(item)"
        >mdi mdi-hand-back-left</v-icon
      >
    </template>
    <template #item.status="{ value }">
      <v-chip v-if="value === 'Pending'" color="orange" outlined>{{
        value
      }}</v-chip>
      <v-chip v-if="value === 'In Progress'" color="green" outlined>{{
        value
      }}</v-chip>
    </template>
    <template #item.last_user_save="{ value }">
      {{ value ? $parseDate(value, "yyyy-MM-dd HH:mm") : "-" }}
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-btn text color="primary" @click="editItemPopUp(item)">
          Edit Description
        </v-btn>
        <v-btn text color="primary" @click="editItem(item)"> More </v-btn>
        <!-- <v-btn
          text
          color="primary"
          v-if="a_sor && !a_sor.finalised_at"
          @click="deleteItem(item)"
        >
          Delete
        </v-btn> -->
      </div>
    </template>
  </RbuSectionItemPaginatedList>
</template>

<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import RemotePaginatedList from "../RemotePaginatedList";
import RbuSectionItemPaginatedList from "../RbuSectionItemPaginatedList";
import { ACTION_TYPES } from "@/store/types";
import { PERMISSIONS } from "@/constants";
import EditDescriptionDialog from "./EditDescriptionDialog.vue";

export default {
  name: "ASorItemList",
  components: { RemotePaginatedList, RbuSectionItemPaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,
    a_sor: Object,
  },
  setup(props, { root, emit }) {
    const innerRefreshTrigger = ref(false);
    const dataUrl = ref("admin/contract/a_sor/a_sor_item/");

    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );
    const parseRemark = function (value) {
      // only show the first 25 characters, else using ...
      return value.length > 25 ? `${value.slice(0, 25)}...` : value;
    };

    // Filter
    const filterOptions = ref([
      {
        text: root.$t("rbu_item.dummy_item_no"),
        value: "dummy_item_no",
        contains: true,
      },

      {
        text: root.$t("rbu_item.need_manual_update"),
        value: "need_manual_update",
        options: [
          { text: "YES", value: true },
          { text: "NO", value: false },
        ],
      },
    ]);

    // Data Table
    const headers = computed(() => {
      return [
        {
          text: root.$t("rbu_item.dummy_item_no"),
          value: "dummy_item_no",
        },
        {
          text: root.$t("rbu_item.item_remark"),
          value: "item_remark",
        },
        {
          text: root.$t("rbu_item.need_manual_update"),
          value: "need_manual_update",
        },
        {
          text: root.$t("rbu_item.status"),
          value: "status",
        },
        {
          text: root.$t("rbu_item.last_update_date"),
          value: "last_user_save",
        },
        { text: "", value: "actions", sortable: false, width: 100 },
      ];
    });

    const editItem = async function (item) {
      root.$router.push({
        name: "a-sor-rbu-item-detail",
        params: { rbuItemId: item.id },
      });
    };
    const deleteItem = async function (item) {
      if (
        await root.$dialog.confirm({
          text: `Delete RBU Item - ${item.dummy_item_no} ?`,
        })
      ) {
        // TODO DELETE
        // const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        //   url: "admin/rbu/item/delete/",
        //   params: { item_id: item.id },
        // });
        // await refresh();
        // emit("update:refresh-mapping-trigger", true);
      }
    };

    const resetManuallySelected = async (item) => {
      const confirmReset = await root.$dialog.confirm({
        text: "Are you sure to disable the Manually Selected Rate? (Yes/No)",
        title: "Confirm Reset",
      });
      if (confirmReset) {
        // TODO RESET
        // const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        //   url: "admin/rbu/item/reset_selected_adopted_rate_type/",
        //   params: { item_id: item.id },
        // });
        // await refresh();
      }
    };

    const editItemPopUp = async (item) => {
      const success = await root.$dialog.showAndWait(EditDescriptionDialog, {
        showClose: false,
        persistent: true,
        a_sor_id: props.a_sor.id,
        rbu_item: item,
      });

      refresh();
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,

      editItem,
      deleteItem,

      PERMISSIONS,
      parseRemark,

      resetManuallySelected,
      dataUrl,
      editItemPopUp,
    };
  },
};
</script>

<style lang="less"></style>
